import type { PagamentoVeiculo } from '../../types'

/** Forma de pagamento do formulário: conta ou cartão (o crédito pode parcelar quando `comParcelas`). */
export interface PagamentoForm { meio: 'conta' | 'cartao'; accountId: string; cartaoId: string; debito: boolean; numParcelas: string }

export const pagamentoVazio = (): PagamentoForm => ({ meio: 'cartao', accountId: '', cartaoId: '', debito: false, numParcelas: '1' })

export const pagamentoValido = (p: PagamentoForm) => (p.meio === 'conta' ? !!p.accountId : !!p.cartaoId)

export const montarPagamento = (p: PagamentoForm): PagamentoVeiculo =>
  p.meio === 'conta' ? { accountId: p.accountId } : { cartaoId: p.cartaoId, debito: p.debito || undefined }
